import React from 'react';
import { FaGithub } from 'react-icons/fa';

function Footer() {
  return (
    <footer>
      <h2>Monied Ⓒ 2022 <span><a href="https://github.com/sfhill24/Monied-2"><span id="gitHub"><FaGithub size={40} color="black" className="main-nav-icon" /></span></a> </span></h2> 
      
    </footer>
  );
}

export default Footer;
